const PREFIX = 'POST'

export const POST_LOADING_STATUS = `${PREFIX}_LOADING_STATUS`

export const POST_GET = `${PREFIX}_GET`
export const POST_GET_ERROR = `${PREFIX}_GET_ERRORS`
export const POST_GET_ERROR_NOT_FOUND = `${PREFIX}_GET_ERRORS_NOT_FOUND`

export const POST_ADD = `${PREFIX}_ADD`
export const POST_UPLOAD_FILE = `${PREFIX}_UPLOAD_FILE`
export const POST_FILE_LOADING_STATUS = `${PREFIX}_FILE_LOADING_STATUS`
export const POST_ADD_ERROR = `${PREFIX}_ADD_ERRORS`
export const POSTS_FETCH = `${PREFIX}_FETCH`
export const POSTS_FETCH_ERROR = `${PREFIX}_FETCH_ERRORS`
export const POST_UPDATE = `${PREFIX}_UPDATE`
export const POST_UPDATE_ERROR = `${PREFIX}_UPDATE_ERRORS`
export const POST_DELETE = `${PREFIX}_DELETE`
export const POST_DELETE_ERROR = `${PREFIX}_DELETE_ERRORS`

export const POSTS_FETCH_BY_AUTHOR = `${PREFIX}_FETCH_BY_AUTHOR`
export const POSTS_FETCH_BY_AUTHOR_ERROR = `${PREFIX}_FETCH_BY_AUTHOR_ERROR`

export const POSTS_FETCH_BY_CATEGORY = `${PREFIX}_FETCH_BY_CATEGORY`
export const POSTS_FETCH_BY_CATEGORY_ERROR = `${PREFIX}_FETCH_BY_CATEGORY_ERROR`

export const POST_COMMENT_GET = `${PREFIX}_COMMENT_GET`
export const POST_COMMENT_GET_ERROR = `${PREFIX}_COMMENT_GET_COMMENT_ERROR`
export const POST_COMMENT_GET_STATUS = `${PREFIX}_COMMENT_GET_COMMENT_STATUS`

export const POST_COMMENTS_GET = `${PREFIX}_COMMENTS_GET`
export const POST_COMMENTS_GET_ERROR = `${PREFIX}_COMMENTS_GET_ERROR`

export const POST_COMMENT_LIKE_STATUS = `${PREFIX}_COMMENTS_LIKE_STATUS`
export const POST_COMMENT_LIKE = `${PREFIX}_COMMENTS_LIKE`
export const POST_COMMENT_LIKE_ERROR = `${PREFIX}_COMMENTS_LIKE_ERROR`


export const POST_COMMENT_ADD = `${PREFIX}_COMMENT_ADD`
export const POST_COMMENT_ADD_ERROR = `${PREFIX}_COMMENT_ADD_COMMENT_ERROR`
export const POST_COMMENT_ADD_STATUS = `${PREFIX}_COMMENT_ADD_COMMENT_STATUS`

export const POST_EVENT_COMMENT_ADD_STATUS = `${PREFIX}_EVENT_COMMENT_ADD_STATUS`
export const POST_EVENT_COMMENT_ADD = `${PREFIX}_EVENT_COMMENT_ADD`
export const POST_EVENT_COMMENT_ADD_ERROR = `${PREFIX}_EVENT_COMMENT_ADD_ERROR`

export const POST_COMMENT_UPDATE = `${PREFIX}_COMMENT_UPDATED`
export const POST_COMMENT_UPDATE_ERROR = `${PREFIX}_COMMENT_UPDATE_ERROR`
export const POST_COMMENT_UPDATE_STATUS = `${PREFIX}_COMMENT_UPDATE_STATUS`

export const POST_COMMENT_REPLY = `${PREFIX}_COMMENT_REPLY`
export const POST_COMMENT_REPLY_ERROR = `${PREFIX}_COMMENT_REPLY_ERROR`
export const POST_COMMENT_REPLY_STATUS = `${PREFIX}_COMMENT_REPLY_STATUS`

export const POST_COMMENT_DELETE = `${PREFIX}_COMMENT_DELETE`
export const POST_COMMENT_DELETE_ERROR = `${PREFIX}_COMMENT_DELETE_ERROR`
export const POST_COMMENT_DELETE_STATUS = `${PREFIX}_COMMENT_DELETE_STATUS`

export const POST_COMMENT_REPLY_DELETE = `${PREFIX}_COMMENT_REPLY_DELETE`
export const POST_COMMENT_REPLY_DELETE_ERROR = `${PREFIX}_COMMENT_REPLY_DELETE_ERROR`
export const POST_COMMENT_REPLY_DELETE_STATUS = `${PREFIX}_COMMENT_REPLY_DELETE_STATUS`

export const POSTS_NEARBY_FETCH = `${PREFIX}_NEARBY_GET`
export const POSTS_NEARBY_FETCH_ERROR = `${PREFIX}_NEARBY_GET_ERROR`
export const POSTS_NEARBY_FETCH_LOADING = `${PREFIX}_NEARBY_GET_LOADING`

export const POST_FEATURED_GET = `${PREFIX}_FEATURED_GET`
export const POST_FEATURED_GET_ERROR = `${PREFIX}_FEATURED_GET_ERROR`
export const POST_FEATURED_LOADING = `${PREFIX}_FEATURED_GET_STATUS`

export const POST_REPORT = `${PREFIX}_REPORT`
export const POST_REPORT_ERROR = `${PREFIX}_REPORT_ERROR`
export const POST_REPORT_STATUS = `${PREFIX}_REPORT_STATUS`

export const POST_VIOLATIONS_GET = `${PREFIX}_VIOLATIONS_GET`
export const POST_VIOLATIONS_GET_ERROR = `${PREFIX}_VIOLATIONS_GET_ERROR`

export const POST_POLL_VOTING = `${PREFIX}_POLL_VOTING`
export const POST_POLL_VOTING_ERROR = `${PREFIX}_POLL_VOTING_ERROR`
export const POST_POLL_LIST_UPDATE = `${PREFIX}_POLL_LIST_UPDATE`

export const POST_UPDATE_STATUS = `${PREFIX}_UPDATE_STATUS`

export const POST_POLL_TIMER = `${PREFIX}_POLL_TIMER`
export const POST_POLL_TIMER_LOADING = `${PREFIX}_POLL_TIMER_LOADING`

export const POST_POLL_USERS = `${PREFIX}_POLL_USERS`
export const POST_POLL_USERS_LOADING = `${PREFIX}_POLL_USERS_LOADING`

export const POST_POLL_STOP = `${PREFIX}_POLL_STOP`

export const POST_VIDEO_PREVIEW = `${PREFIX}_VIDEO_PREVIEW`
export const POST_VIDEO_PREVIEW_LOADING = `${PREFIX}_VIDEO_PREVIEW_LOADING`
export const POST_VIDEO_PREVIEW_ERROR = `${PREFIX}_VIDEO_PREVIEW_ERROR`
